module.exports = __webpack_public_path__ + "static/img/logo_fencom_horizontal_negativo.04b6170.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_fencom_horizontal_negativo.png
// module id = TMTn
// module chunks = 1